import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const PRESETS = [
  { name: 'Indigo',   hex: '#422AFB' },
  { name: 'Cobalt',   hex: '#2563EB' },
  { name: 'Sky',      hex: '#0EA5E9' },
  { name: 'Teal',     hex: '#0D9488' },
  { name: 'Emerald',  hex: '#10B981' },
  { name: 'Lime',     hex: '#65A30D' },
  { name: 'Amber',    hex: '#F59E0B' },
  { name: 'Coral',    hex: '#F97316' },
  { name: 'Crimson',  hex: '#DC2626' },
  { name: 'Pink',     hex: '#EC4899' },
  { name: 'Plum',     hex: '#9333EA' },
  { name: 'Slate',    hex: '#475569' },
];

/**
 * Curated brand color swatches + custom hex picker. Tied into the brand
 * settings form via `value` (current hex) and `onPick(hex)`.
 */
export default function BrandColorPresets({ value, onPick }) {
  const current = (value || '').toLowerCase();
  return (
    <Box mt='8px'>
      <Typography variant='caption' color='text.secondary' mb='6px' display='block'>
        Or pick a preset
      </Typography>
      <Stack direction='row' flexWrap='wrap' gap='6px'>
        {PRESETS.map((c) => {
          const active = current === c.hex.toLowerCase();
          return (
            <Box
              key={c.hex}
              component='button'
              type='button'
              onClick={() => onPick(c.hex)}
              title={`${c.name} (${c.hex})`}
              sx={{
                width: 26,
                height: 26,
                borderRadius: '8px',
                bgcolor: c.hex,
                border: '2px solid',
                borderColor: active ? 'grey.900' : 'transparent',
                outline: active ? '2px solid white' : 'none',
                outlineOffset: '-4px',
                cursor: 'pointer',
                transition: 'transform 120ms ease, border-color 120ms ease',
                p: 0,
                '&:hover': { transform: 'scale(1.08)' },
              }}
            />
          );
        })}
        <Box
          component='label'
          title='Custom hex'
          sx={{
            ml: '4px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 26,
            height: 26,
            borderRadius: '8px',
            border: '1px dashed',
            borderColor: 'grey.400',
            cursor: 'pointer',
          }}
        >
          <Typography variant='caption' color='text.secondary'>+</Typography>
          <input
            type='color'
            value={value && /^#[0-9a-f]{6}$/i.test(value) ? value : '#422AFB'}
            onChange={(e) => onPick(e.target.value.toUpperCase())}
            style={{ position: 'absolute', opacity: 0, width: 1, height: 1, padding: 0, margin: -1, border: 0 }}
          />
        </Box>
      </Stack>
    </Box>
  );
}
